// Module
var code = "<div class=\"noAccess\" title=\"Access denied\"><i class=\"fa fa-ban\" aria-hidden=\"true\"></i></div>";
// Exports
export default code;